import React from 'react'
import styled from '@emotion/styled'

import { MdOutlineKeyboardArrowUp } from 'react-icons/md'

const TopBtn: React.VFC = () => {
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <Wrapper type="button" onClick={handleClick}>
      <MdOutlineKeyboardArrowUp />
    </Wrapper>
  )
}

const Wrapper = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 10;

  width: 50px;
  height: 50px;
  border-radius: 50%;

  background-color: ${({ theme: { colors } }) => colors.defaultText};
  color: ${({ theme: { colors } }) => colors.bgColor};

  @media ${({ theme: { device } }) => device.mobile} {
    bottom: 17px;
    right: 17px;
    width: 40px;
    height: 40px;
  }
`

export default TopBtn
